var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.isClickable ? _c('span', [_vm._v(_vm._s(_vm.number))]) : _c('span', [_c('b-link', {
    class: _vm.linkClass,
    on: {
      "click": _vm.openModal
    }
  }, [_vm._v(_vm._s(_vm.number))]), _c('b-modal', {
    attrs: {
      "title": `Informatie over product ${_vm.number}`,
      "hide-footer": ""
    },
    model: {
      value: _vm.isModalOpen,
      callback: function ($$v) {
        _vm.isModalOpen = $$v;
      },
      expression: "isModalOpen"
    }
  }, [_c('product-info', {
    attrs: {
      "number": _vm.number,
      "sales-order-line": _vm.salesOrderLine,
      "dispatch-request-line": _vm.dispatchRequestLine,
      "product-name": _vm.productName,
      "show-only-fields": _vm.showOnlyFields
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }